import PropTypes from 'prop-types';

import { STORIES, STORY } from '@/lib/posts/postTypes';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

import FacebookPost from '@/components/base/Post/FacebookPost';
import InstagramPost from '@/components/base/Post/InstagramPost';
import InstagramStory from '@/components/base/Post/InstagramStory';
import LinkedinPost from '@/components/base/Post/LinkedinPost';
import PinterestPost from '@/components/base/Post/PinterestPost';
import TiktokPost from '@/components/base/Post/TiktokPost';
import TwitterPost from '@/components/base/Post/TwitterPost';
import YoutubePost from '@/components/base/Post/YoutubePost';

export const PostComponent = ({ network, type, data, config, ...restProps }) => {
    switch (network) {
        case INSTAGRAM: {
            const isStory = type === STORIES || data?.type === STORY;
            if (isStory) {
                return (
                    <InstagramStory
                        data={data}
                        config={{ ...config, postType: STORY, postFormat: STORY }}
                        {...restProps}
                    />
                );
            }
            return <InstagramPost data={data} config={config} {...restProps} />;
        }
        case TIKTOK_BUSINESS:
            return <TiktokPost data={data} config={config} {...restProps} />;
        case FACEBOOK:
            return <FacebookPost data={data} config={config} {...restProps} />;
        case LINKEDIN:
            return <LinkedinPost data={data} config={config} {...restProps} />;
        case PINTEREST:
            return <PinterestPost data={data} config={config} {...restProps} />;
        case X:
            return <TwitterPost data={data} config={config} {...restProps} />;
        case YOUTUBE:
            return <YoutubePost data={data} config={config} {...restProps} />;
        default:
            return <InstagramPost data={data} config={config} {...restProps} />;
    }
};

PostComponent.propTypes = {
    network: PropTypes.oneOf([
        INSTAGRAM,
        FACEBOOK,
        LINKEDIN,
        PINTEREST,
        X,
        TIKTOK_BUSINESS,
        YOUTUBE
    ]),
    type: PropTypes.oneOf(['medias', 'stories'])
};
